import type { PageDimensions } from '@aline/common';

export type Orientation = 'landscape' | 'portrait';

export type PageSizeName =
  | 'A3'
  | 'A4'
  | 'A5'
  | 'B4'
  | 'B5'
  | 'Executive'
  | 'Folio'
  | 'Legal'
  | 'Letter'
  | 'Statement'
  | 'Tabloid';

export type PageSize = {
  height: number;
  name: PageSizeName;
  shortlist: boolean;
  width: number;
};

const letterPageSize: PageSize = { height: 11, name: 'Letter', shortlist: true, width: 8.5 };
export const pageSizes: PageSize[] = [
  letterPageSize,
  { height: 17, name: 'Tabloid', shortlist: false, width: 11 },
  { height: 14, name: 'Legal', shortlist: true, width: 8.5 },
  { height: 8.5, name: 'Statement', shortlist: false, width: 5.5 },
  { height: 10.5, name: 'Executive', shortlist: true, width: 7.25 },
  { height: 13, name: 'Folio', shortlist: false, width: 8.5 },
  { height: 16.54, name: 'A3', shortlist: false, width: 11.69 },
  { height: 11.69, name: 'A4', shortlist: true, width: 8.27 },
  { height: 8.27, name: 'A5', shortlist: true, width: 5.83 },
  { height: 13.9, name: 'B4', shortlist: false, width: 9.84 },
  { height: 9.84, name: 'B5', shortlist: false, width: 6.93 },
];

export function getPageSizeByName(name: PageSizeName, landscape = false): PageSize {
  const pageSize = pageSizes.find(pageSize => pageSize.name === name) ?? letterPageSize;
  if (landscape) return { ...pageSize, height: pageSize.width, width: pageSize.height };

  return pageSize;
}

export function getPageSizeByPageDimensions(pageDimensions: PageDimensions): PageSize {
  const isLandscape = pageDimensions.width > pageDimensions.height;
  const height = isLandscape ? pageDimensions.width : pageDimensions.height;
  const width = isLandscape ? pageDimensions.height : pageDimensions.width;
  const pageSize = pageSizes.find(
    pageSize => pageSize.height === height && pageSize.width === width
  );

  return pageSize ?? letterPageSize;
}

export function parseValue(value: string): number | null {
  const matches = value.replace(/\s/g, '').match(/^-?\d+(\.\d)?$/);
  if (matches) return parseFloat(matches[0]);

  return null;
}
